// extracted by mini-css-extract-plugin
export default {"rootContainer":"ProductItemsSelector_rootContainer__izMWR"};